import { initializeApp } from "@firebase/app";
import { getAuth } from "@firebase/auth";
import {
  getFirestore,
  connectFirestoreEmulator,
  initializeFirestore,
} from "@firebase/firestore";
import { getStorage } from "@firebase/storage";

const firebaseConfig = {
  apiKey: process.env.VITE_FIREBASE_API_KEY,
  authDomain: process.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig ? firebaseConfig : {});

const auth = getAuth(app);

initializeFirestore(app, {
  ignoreUndefinedProperties: true,
});
const db = getFirestore(app);

const isProd = process.env.NODE_ENV === "production";
const runEmulator = false;

if (!isProd && runEmulator && !isProd) {
  connectFirestoreEmulator(db, "localhost", 5002);
}
const storage = getStorage(app);

export { auth, app, firebaseConfig, db, storage };
